import API from "../../api";

export default {
  namespaced: true,

  state: {},

  actions: {
    async create({ commit }, data) {
      try {
        await API.Districts.create(data);
        return true;
      } catch (e) {
        throw e;
      }
    },

    async searchByCityAndName({ commit }, data) {
      try {
        return await API.Districts.searchByCityAndName(data)[0];
      } catch (e) {
        throw e;
      }
    }
  },

  mutations: {},

  getters: {}
};



// WEBPACK FOOTER //
// ./src/store/modules/districts.js